// アプリから撤去した画面のURL。
// バックエンドは過去データの参照用に従来のURLを返し続ける（API・データは変更しない方針）
// ため、「遷移させない」判断はフロント側の責任になる。ここが唯一の定義元。
// 撤去済みURLはレコードの表示は残したまま、リンクだけ無効化する
// （消すと「どこで使われていたか」が分からなくなるため）。
const RETIRED_PREFIXES = [
  '/engineering/item-flow',   // 旧アイテムフロー: 開発案件管理へ移行し画面を撤去
];

/** 生きている画面のURLならそのまま返す。撤去済みなら null（=リンクにしない）。 */
export const liveUrl = (url) => {
  const u = typeof url === 'string' ? url : '';
  if (!u) return null;
  return RETIRED_PREFIXES.some((p) => u.startsWith(p)) ? null : u;
};
